import { render, staticRenderFns } from "./publiccontroltitle.vue?vue&type=template&id=2a2de8c6&"
import script from "./publiccontroltitle.vue?vue&type=script&lang=js&"
export * from "./publiccontroltitle.vue?vue&type=script&lang=js&"
import style0 from "./publiccontroltitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports